import { Validator } from '~/types';
import i18n from '~/i18n';

const t = i18n.t.bind(i18n);

const regexValidation = (pattern: string): Validator => {
  return (rule, value, callback) => {
    try {
      const re = new RegExp(pattern);
      if (!re.test(value)) {
        throw new Error(t('regexValidationError', { pattern }));
      }
      callback();
    } catch (err: any) {
      callback(err);
    }
  };
};

const basicValidation = (pattern: string): Validator => {
  const f: Validator = (rule, value, callback) => {
    if (rule.required && !value) {
      callback(t('required'));
    } else if (value) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const v = regexValidation(pattern)!;
      void v(rule, value, callback);
    } else {
      callback();
    }
  };
  return f;
};

export default basicValidation;
